export default __webpack_public_path__ + "static/media/icon04.10b7305b.png";